/** Matches backend promotion.condition.type.js */
const PromotionType = {
  DISCOUNT: 0,
  CONDITIONAL: 1,
  COMBINED: 2,
  PROMO_CODE: 3,
  CONDITIONAL_DISCOUNT: 4,
  COMBINED_DISCOUNT: 5
}

export const PromotionTypeLabel = {
  [PromotionType.DISCOUNT]: '🏷️ Скидки',
  [PromotionType.CONDITIONAL]: (<>Покупка на <br /> N сом + 🎁</>),
  [PromotionType.COMBINED]: 'N покупок + 🎁',
  [PromotionType.PROMO_CODE]: '🎟️ Промокоды',
}

export default PromotionType
